import { useIntl } from 'react-intl'
import { useEffect, useState } from 'react'
import ShareModal from '../../widgets/components/ShareModal'
import { getReferralData } from '../../profile/core/_requests'
import { toast } from 'react-toastify'
import Iccopy from '../../../../media/EarlyAccess/ic-copy.svg'
import { useThemeMode } from '../../../../_metronic/partials'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'

export const EarlyInviteCard = () => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [isModalActive, setIsModalActive] = useState(false)
  const [referral, setReferral] = useState<string>()
  const getReferral = async () => {
    try {
      const {
        data: { success, data, errors },
      } = await getReferralData()
      if (success) {
        setReferral(data.fprom_fpr)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getReferral()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='p-6 text-white rounded-2' style={{ background: '#0D216D' }}>
        <h1 className=' font-size-20 lh-32 text-white'>
          {formatMessage({ id: `Want Early Access? Invite & Jump Ahead!` })}
        </h1>

        <div className='mt-8'>
          <h3 className='text-white'>{formatMessage({ id: `Rules:` })}</h3>
          <p className='m-0 mt-2'>{formatMessage({ id: ` Invite 1 user → Move up 50 spots` })}</p>
          <p className='m-0 mt-2'>
            {formatMessage({ id: ` Invite 10+ Users → Get priority access` })}
          </p>
        </div>

        <div
          className={`alert p-2 mt-4 alert-warning`}
          style={{ color: '#383940', background: `${mode === 'dark' ? '#FFF8DD' : ''}` }}
        >
          <p className='font-size-13 fw-semibold m-0'>
            {formatMessage({
              id: `Top referrers this week will get early access + 1 free premium month!`,
            })}
          </p>
        </div>

        {/* Invite Link */}
        <div className='mb-4 mt-8'>
          <div className='d-flex align-items-center mb-1'>
            <p className='text-white font-size-13 m-0 text-white'>{formatMessage({ id: 'Referral Link' })}</p>
            <ToolTipUI tooltipText={'Share this unique link to invite others. Each successful referral moves you up the waitlist - invite 1 user to jump 50 spots, or invite 10+ users for priority access. Track your referrals in real-time below.'} />
          </div>
        </div>
        <div
          className='d-flex gap-4 align-items-center justify-content-between rounded-2 bg-white'
          style={{ color: '#33353A', background: '#FFFFFF' }}
        >
          <input
            type='text'
            className={`p-4 border border-0 w-100 bg-white rounded-2 ${mode === 'dark' ? 'text-white' : ''}`}
            value={`${window.location.protocol}//${window.location.hostname}/auth/registration?fpr=${referral}`}
            placeholder={formatMessage({ id: 'Some path' })}
            readOnly
          />
          <span
            className='px-2 cursor-pointer bg-white'
            onClick={() => {
              navigator.clipboard.writeText(
                `${window.location.protocol}//${window.location.hostname}/auth/registration?fpr=${referral}`
              )
              toast.success(formatMessage({ id: 'Copied Successfully' }))
            }}
          >
            <img src={Iccopy} alt='' />
          </span>
        </div>

        <button className='w-100 mt-4 btn btn-primary' onClick={() => setIsModalActive(true)}>
          {formatMessage({ id: `Share` })}
        </button>
      </div>
      <ShareModal
        isActive={isModalActive}
        setIsActive={setIsModalActive}
        url={`${window.location.protocol}//${window.location.hostname}/auth/registration?fpr=${referral}`}
      />
    </>
  )
}
